import { BaseModel, IModelOptions } from './BaseModel';
import { IMultiNavigationData } from 'types/navigation';

export type IMemorySemanticUnifierItemRow = {
  id: number;
  pattern: string;
  count: number;
  navigation_data?: IMultiNavigationData;
  items?: Array<{ translation_id: number; course_id: number }>;
};

export default class MemorySemanticUnifierItemsModel extends BaseModel<IMemorySemanticUnifierItemRow> {
  dialectId = 0;
  parentModel: any;
  currentGroupRow: any;
  constructor(options: IModelOptions) {
    super(options);
    this.gridName = 'MemorySemanticUnifierItems';
    this.getGridColumns();
  }

  setDialectId(id: number) {
    this.dialectId = id;
  }

  setParentModel(parent: any) {
    this.parentModel = parent;
  }

  setCurrentGroup(row: any) {
    this.currentGroupRow = row;
  }

  reset() {
    this.gridData = [] as any;
    this.gridDataUpdateRow = { type: 'none', data: null } as any;
    this.render();
  }

  setMembers(members: Array<IMemorySemanticUnifierItemRow>) {
    this.gridData = (members || []).map((m) => ({ ...m }));
    // Columns (including actions) are defined server-side via GridColumns service
    this.render();
  }

  // Return the full current row object so Grid.updateRow('update') can refresh cells without losing data
  async getGridRow(itemId: number) {
    const row = (this.gridData as any[]).find((r) => r && r.id === itemId);
    return row || { id: itemId };
  }

  /**
   * Apply a local member change: mark as changed, update pattern, and persist into the parent group
   * so it survives when switching groups. Triggers renders for both models.
   */
  async applyMemberChange(memberId: number, editedPattern?: string) {
    try {
      // Debug current state
      // eslint-disable-next-line no-console
      // state updated

      // 1) Update right grid row (immutable replace)
      const rows: any[] = Array.isArray(this.gridData) ? (this.gridData as any) : [];
      const idx = rows.findIndex((r) => r && r.id === memberId);
      if (idx === -1) {

      } else {
        const nextRow = { ...rows[idx], __changed: true } as any;
        if (editedPattern) nextRow.pattern = editedPattern;
        rows[idx] = nextRow;
        this.gridData = rows.slice();
        // eslint-disable-next-line no-console
        // row updated
      }
      this.render();
      // Force grid to refresh this row using the overridden getGridRow()
      await this.updateGridRow(memberId, 'update');

      // 2) Persist into parent group so reloading the group reflects the change
      const parent = this.parentModel;
      const currentGroup = this.currentGroupRow;
      if (!parent || !currentGroup || !Array.isArray(parent.gridData)) {

        return;
      }
      const gid = currentGroup.id;
      const gIdx = parent.gridData.findIndex((g: any) => g && g.id === gid);
      if (gIdx === -1) {

        return;
      }
      const grp = parent.gridData[gIdx];
      const members = Array.isArray(grp.members) ? grp.members.slice() : [];
      const mIdx = members.findIndex((m: any) => m && m.id === memberId);
      if (mIdx === -1) {

      } else {
        const nextMem = { ...members[mIdx], __changed: true } as any;
        if (editedPattern) nextMem.pattern = editedPattern;
        members[mIdx] = nextMem;
        parent.gridData[gIdx] = { ...grp, members };
        // Keep local reference in sync
        this.currentGroupRow = { ...currentGroup, members };
        // eslint-disable-next-line no-console
        // group updated
        try {
          parent.render();
        } catch {}
      }
    } catch (e) {
      console.error('[MSU] applyMemberChange() failed', e);
    }
  }
}
